/** 列表选择单条判断 */
export function checkSelect(rows) {
  if (rows.length <= 0) {
    this.message.error('请选择一条数据');
    return false;
  } else if (rows.length > 1) {
    this.message.error('只能选择一条数据');
    return false;
  } else {
    return true;
  }
}
/** 列表选择判断,选择多条 */
export function checkSelectList(rows) {
  if (rows.length <= 0) {
    this.message.error('请最少选择一条数据');
    return false;
  } else {
    return true;
  }
}
